import { get, push, ref, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetItemData from "../../../Comman/GetItemData";

const EditAssignerUserItemDataInFirebase = async (state, dispatch, itemData, ownerUid) => {
    if (!ownerUid) return null;
    const USERID = state?.USERID;
    // if (!USERID || !Array.isArray(itemData)) return null;

    try {
        const itemsRef = ref(database, `invoiceGenerator/users/${ownerUid}/items`);
        const snapshot = await get(itemsRef);
        const existingItems = snapshot.val() || {};

        const existingItemsArray = Object.entries(existingItems); // [ [key, value], [key, value], ... ]

        for (let newItem of itemData) {
            let matchedItem = null;
            let matchedKey = null;

            for (let [key, existingItem] of existingItemsArray) {
                if (
                    existingItem.name?.toLowerCase() === newItem.name?.toLowerCase()
                ) {
                    matchedItem = existingItem;
                    matchedKey = key;
                    break;
                }
            }

            if (matchedItem && matchedKey) {
                // Update existing item price

                const itemUpdateRef = ref(database, `invoiceGenerator/users/${ownerUid}/items/${matchedKey}`);
                await update(itemUpdateRef, {
                    updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                    ...matchedItem,
                    defaultPrice: newItem.price, // only update price
                    updatedAt: Date.now()?.toString(),
                });

            } else {
                // Add new item
                const cleanedItem = {
                    itemId: Date.now().toString(),
                    name: newItem?.name,
                    defaultPrice: newItem.price || "0.00",
                    purchasePrice: "0.00",
                    subtitle: newItem.subtitle || "", // optional
                    createdDate: Date.now().toString(),
                    updatedDate: Date.now().toString(),
                };
                await push(itemsRef, cleanedItem);
            }
        }

        await GetItemData(state, dispatch);

    } catch (error) {
        return null;
    }
};

export default EditAssignerUserItemDataInFirebase;
